import * as React from 'react';
import { MasterModel } from './masterModel';
import { HomeModel } from './homeModel';
import { AboutUsModel } from './AboutUsModel';
import { ServicesModel } from './servicesModel';
import { ContactsModel } from './contactsModel';

export class MainModel {

    public MasterModel?: MasterModel = null;
    public HomeModel?: HomeModel = null;
    public AboutUsModel?: AboutUsModel = null;
    public ServicesModel?: ServicesModel = null;
    public ContactsModel?: ContactsModel = null;
    public MasterPageFaliedToLoad?: boolean = false;
    public HomePageFaliedToLoad?: boolean = false;
    public AboutUsFaliedToLoad?: boolean = false;
    public ServicesFaliedToLoad?: boolean = false;
    public ContactsFaliedToLoad?: boolean = false;
    public IsMasterLoading?: boolean = false;
    public IsPageLoading?: boolean = false;
    public children?: React.ReactNode;
    public dispatch?: (data: any) => void;
    public handleSubmit? (onSubmit: (formValues: any) => void);
}




// WEBPACK FOOTER //
// ./ClientApp/app/Models/mainModel.tsx